import { Fragment, h } from "preact";
import { useEffect, useState } from "preact/hooks";

import CheckboxInput from "../Checkbox.jsx";

export default function Checkbox(props) {
  const [value, setValue] = useState(null);

  function handleChange(event) {
    setValue(event.target.checked);
    props.onSelect(event.target.checked);
  }

  useEffect(() => {
    setValue(props.answer);
  }, []);

  return (
    <Fragment>
      <CheckboxInput
        id="question-checkbox"
        name="answer"
        class="mt-16 mb-32 pl-0"
        onChange={handleChange}
        checked={value}
      >
        {props.options.label || props.title}
      </CheckboxInput>
    </Fragment>
  );
}
